function cookiepolicy() {
  $("#c0ke").hide()
  document.cookie = "_cookiepolicy=true; path=/; max-age=2592000;"
  return false
}

export function setupCookiePolicy() {
  var btn = '<a href="#"  class="btn btn-primary c0ke__accept">Akceptuję</a>'
  var text =
    "Ten serwis www używa cookies (ciasteczek). Korzystanie z naszego serwisu jest jednoczesnym wyrażeniem zgody na używanie cookies (ciasteczek) w zakresie opisanym " +
    'w <a class="cookie-url" href="' +
    window.cookiePolicyUrl +
    '">polityce cookies</a>, zgodnie z aktualnymi ustawieniami przeglądarki. Można zmienić ustawienia w przeglądarce tak aby nie pobierała ona ciasteczek.'

  if (window.lang === "en") {
    btn = '<a href="#"  class="btn btn-primary c0ke__accept">Accept</a>'
    text =
      'This website uses cookies (cookies). Using our website is a simultaneous consent to the use of cookies (cookies) in the scope described in <a class="c0ke__a" href="' +
      window.cookiePolicyUrl +
      '">the cookie policy</a>, in accordance with the current browser settings. You can change the settings in the browser so that it does not download cookies.'
  }
  var cookiePolicyText =
    '<div class="c0ke" id="c0ke"><div class="container c0ke__inner"><div class="row"><div class="col-md-8">' +
    text +
    '</div><div class="col-md-4 c0ke__right">' +
    btn +
    "</div></div></div></div>"

  if (document.cookie.indexOf("_cookiepolicy=true") === -1) {
    $("body")
      .css("padding-bottom", 120)
      .append(cookiePolicyText)
    $(".c0ke__accept").on("click", cookiepolicy)
  }
}
